import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { kebabCase } from '@makemydeal/dr-common-utils';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { paymentActionCreators } from '@makemydeal/dr-offer-redux';

import { DAYS_TO_FIRST_PAYMENT, DAYS_TO_FIRST_PAYMENT_ABBREVIATED } from '../../../constants';
import { dealLockHooks } from '../../../hooks';
import { usePaymentCall } from '../../../utils/usePaymentCall';

export const useDaysToFirstPaymentField = () => {
    const isPaymentError = useSelector(offerReduxSelectors.getIsError);
    const actionForPayment = useSelector(offerReduxSelectors.getActionForPayment);
    let termDaysToPayment = useSelector(offerReduxSelectors.getDaysToFirstPaymentBySelectedTerm);
    if (!termDaysToPayment) termDaysToPayment = NaN;
    const isCalculatingPayment = useSelector(offerReduxSelectors.isCalculatingPayment);
    const isLocked = dealLockHooks.useIsDealLocked();
    const {
        value: inputDaysToFirstPayment,
        handleChange,
        handleBlur,
        handleKeyDown
    } = usePaymentCall(offerReduxSelectors.getDaysToFirstPaymentBySelectedTerm, paymentActionCreators.updateDaysToFirstPayment);

    const mounted = useRef(false);
    const validatedTermDays = !isNaN(termDaysToPayment) ? termDaysToPayment : '';
    const [daysToFirstPayment, setDaysToFirstPayment] = useState(validatedTermDays);

    const inputDays = !isNaN(parseInt(inputDaysToFirstPayment)) ? parseInt(inputDaysToFirstPayment) : '';

    useEffect(() => {
        if (!isCalculatingPayment) {
            const errors = isPaymentError && actionForPayment === 'UPDATED_DAYS_TO_FIRST_PAYMENT';
            if (errors) {
                setDaysToFirstPayment(inputDays);
            } else if (validatedTermDays && validatedTermDays !== inputDays) {
                setDaysToFirstPayment(-1);
            } else {
                setDaysToFirstPayment(validatedTermDays || inputDays);
            }
        }
    }, [isCalculatingPayment, isPaymentError]);

    const isDaysToFirstPaymentNegative = daysToFirstPayment === -1;

    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true;
            return;
        }

        setDaysToFirstPayment(termDaysToPayment);
    }, [isDaysToFirstPaymentNegative]);

    return {
        label: DAYS_TO_FIRST_PAYMENT_ABBREVIATED,
        inputProps: {
            id: kebabCase(DAYS_TO_FIRST_PAYMENT),
            name: kebabCase(DAYS_TO_FIRST_PAYMENT),
            value: daysToFirstPayment,
            label: DAYS_TO_FIRST_PAYMENT,
            onBlur: handleBlur,
            onChange: handleChange,
            displayLabel: false,
            disabled: isLocked,
            'data-testid': kebabCase(DAYS_TO_FIRST_PAYMENT),
            size: 'sm' as const,
            onKeyDown: handleKeyDown
        }
    };
};
